import React, { useState } from 'react';

function Templates({ onApplyTemplate }) {
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const templates = [
    {
      id: 'basic-study',
      name: 'Basic Study Guide',
      description: 'A simple template with verses, notes, and questions',
      sections: [
        { type: 'notes', title: 'Study Notes', content: '' },
        { type: 'questions', title: 'Discussion Questions', questions: [] },
        { type: 'observations', title: 'Key Observations', content: '' }
      ]
    },
    {
      id: 'inductive-study',
      name: 'Inductive Study',
      description: 'Comprehensive inductive Bible study template',
      sections: [
        { type: 'notes', title: 'Observation Notes', content: '' },
        { type: 'notes', title: 'Interpretation Notes', content: '' },
        { type: 'notes', title: 'Application Notes', content: '' },
        { type: 'questions', title: 'Observation Questions', questions: [] },
        { type: 'questions', title: 'Interpretation Questions', questions: [] },
        { type: 'questions', title: 'Application Questions', questions: [] },
        { type: 'observations', title: 'Summary', content: '' }
      ]
    },
    {
      id: 'character-study',
      name: 'Character Study',
      description: 'Template for studying biblical characters',
      sections: [
        { type: 'notes', title: 'Character Background', content: '' },
        { type: 'notes', title: 'Key Events', content: '' },
        { type: 'notes', title: 'Character Traits', content: '' },
        { type: 'notes', title: 'Lessons Learned', content: '' },
        { type: 'questions', title: 'Study Questions', questions: [''] },
        { type: 'observations', title: 'Personal Application', content: '' }
      ]
    },
    {
      id: 'thematic-study',
      name: 'Thematic Study',
      description: 'Template for studying biblical themes or topics',
      sections: [
        { type: 'notes', title: 'Theme Definition', content: '' },
        { type: 'notes', title: 'Key Passages', content: '' },
        { type: 'notes', title: 'Biblical Context', content: '' },
        { type: 'notes', title: 'Modern Application', content: '' },
        { type: 'questions', title: 'Reflection Questions', questions: [''] },
        { type: 'observations', title: 'Personal Insights', content: '' }
      ]
    },
    {
      id: 'book-overview',
      name: 'Book Overview',
      description: 'Template for studying an entire book of the Bible',
      sections: [
        { type: 'notes', title: 'Book Introduction', content: '' },
        { type: 'notes', title: 'Author & Context', content: '' },
        { type: 'notes', title: 'Main Themes', content: '' },
        { type: 'notes', title: 'Key Characters', content: '' },
        { type: 'notes', title: 'Outline', content: '' },
        { type: 'questions', title: 'Study Questions', questions: [] },
        { type: 'observations', title: 'Personal Reflection', content: '' }
      ]
    }
  ];

  const handleApplyTemplate = (template) => {
    const sectionsWithIds = template.sections.map(section => ({
      ...section,
      id: Date.now() + Math.random()
    }));
    onApplyTemplate(sectionsWithIds);
    setSelectedTemplate(null);
  };

  return (
    <div className="templates-container">
      <h3>Study Guide Templates</h3>
      <div className="templates-grid">
        {templates.map(template => (
          <div key={template.id} className="template-card">
            <div className="template-header">
              <h4>{template.name}</h4>
              <p>{template.description}</p>
            </div>
            <div className="template-sections">
              <h5>Sections:</h5>
              <ul>
                {template.sections.map((section, index) => (
                  <li key={index}>
                    {section.type === 'questions' ? `${section.title} (${section.questions.length} questions)` : section.title}
                  </li>
                ))}
              </ul>
            </div>
            <button
              className="btn btn-primary"
              onClick={() => handleApplyTemplate(template)}
            >
              Use Template
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Templates;